module.exports = __webpack_public_path__ + "static/img/doujiang.400ffc42.png";